export const PUBLISH_PICTURE_API = '/motor/discuss_ugc/cheyou_publish_forum/v2/'
export const PUBLISH_VIDEO_API = '/motor/content_publish/publish_video/v1'
export const PUBLISH_POST_API = '/motor/discuss_ugc/publish_essay/v1/'
export const DELAY_PUBLISH_PICTURE_API =
  '/motor/discuss_ugc/timed/publish_forum'
export const DELAY_PUBLISH_VIDEO_API = '/motor/discuss_ugc/timed/publish_video'
export const DELAY_PUBLISH_POST_API = '/motor/discuss_ugc/timed/publish_essay'
export const CANCEL_DELAY_PUBLISH_API = '/motor/discuss_ugc/timed/finished'

export const GET_NORMAL_AUTH_API = '/motor/car_user/v1/get_normal_auth/'
export const GET_FEED_LIST_API = '/motor/profile/m/get_news'
export const GET_DELAY_LIST_API = '/motor/discuss_ugc/timed/publish_list'

export const DELETE_FEED_API = '/motor/discuss_ugc/cheyou_delete_forum/v2/'
export const DELETE_VIDEO_API = '/motor/discuss_ugc/delete_video/v1/'
